import { HStack, IconButton, Link, } from '@chakra-ui/react'; 
import { FaTwitter, FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa'; 

export default function SocialLinks() {
     return ( 
     <HStack spacing={4} justify="center" mt={6}> 
        <Link href="https://x.com/swiftchang" isExternal> 
            <IconButton aria-label="Twitter" icon={<FaTwitter />} variant="ghost" fontSize="2xl" color="#1DA1F2" /> 
        </Link> 
        {/*<Link href="https://facebook.com" isExternal> 
            <IconButton aria-label="Facebook" icon={<FaFacebookF />} variant="ghost" fontSize="2xl" color="#1877F2" /> 
        </Link> 
        <Link href="https://instagram.com" isExternal> 
            <IconButton aria-label="Instagram" icon={<FaInstagram />} variant="ghost" fontSize="2xl" color="#E1306C" /> 
        </Link> */}
        <Link href="https://www.linkedin.com/company/swiftchang" isExternal> 
            <IconButton aria-label="LinkedIn" icon={<FaLinkedinIn />} variant="ghost" fontSize="2xl" color="#0A66C2" /> 
        </Link> </HStack> ); }